<mat-form-field appearance="outline" subscriptSizing="dynamic">
  <mat-label>{{ label | translate }}{{ required ? ' *' : '' }}</mat-label>
  <input
    #searchInput
    type="text"
    matInput
    autocomplete="off"
    class="concept-picker__input"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    (focus)="onFocus()"
    (mousedown)="onMouseDown()"
    (mouseup)="onMouseUp($event)"
    (blur)="onBlur()"
  >
  <mat-icon matSuffix>arrow_drop_down</mat-icon>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)"
    (closed)="onPanelClosed()"
  >
    @if (!required) {
      <mat-option [value]="null">–</mat-option>
    }
    @for (option of filteredOptions; track option.id) {
      <mat-option
        class="concept-picker__option"
        [value]="option"
        [style.padding-left.px]="optionIndentPx(option)"
      >
        <span class="concept-picker__leaf">{{ optionLabel(option) }}@if (option.has_authority) {<span class="concept-authority-right"></span>}</span>
        @if (ancestorCrumb(option)) {
          <span class="concept-picker__path">{{ ancestorCrumb(option) }}</span>
        }
      </mat-option>
    }
    @if (searchTerm && !filteredOptions.length) {
      <mat-option disabled>{{ 'TRANS__IMPORT__VALUE_REVIEW__SEARCH_NO_HITS' | translate }}</mat-option>
    }
  </mat-autocomplete>
  @if (selectedCrumb) {
    <mat-hint class="concept-picker__hint">{{ selectedCrumb }}</mat-hint>
  }
</mat-form-field>
